import React, { useState } from "react";
import "./styles/Main.css";
import Header from "./components/Header";
import Menu from "./components/Menu";
import ManagerList from "./components/ManagerList";
import UserList from "./components/UserList";
import BoardList from "./components/Board";
import PasswordModal from "./components/PasswordModal"; // 📌 가져오기

function Main({ user, onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(() => {
    return sessionStorage.getItem("selectedMenu") || "board";
  });
  const [selectedManager, setSelectedManager] = useState(null);
  const [pwModalOpen, setPwModalOpen] = useState(false);

  const handleSelectMenu = (menu) => {
    setSelectedMenu(menu);
    sessionStorage.setItem("selectedMenu", menu);
    if (window.innerWidth < 768) setMenuOpen(false);
  };

  return (
    <div className="main-layout">
      <Header
        user={user}
        onLogout={onLogout}
        onOpenPwModal={() => setPwModalOpen(true)}
        onToggleMenu={() => setMenuOpen(!menuOpen)}
        menuOpen={menuOpen}
        selectedMenu={selectedMenu}
      />

      <div className="body-layout">
        <Menu user={user} onSelect={handleSelectMenu} menuOpen={menuOpen} />

        <section className="content">
          {selectedMenu === "board" && <BoardList loginId={user.login_id} grantFg={user.grant_fg} />}
          {selectedMenu === "manager" && (
            <ManagerList masterId={user.login_id} grantFg={user.grant_fg} onSelectManager={setSelectedManager} />
          )}
          {selectedMenu === "user" && <UserList managerId={user.login_id} grantFg={user.grant_fg} />}
        </section>
      </div>

      {/* 📌 분리된 깔끔한 패스워드 모달 호출 */}
      <PasswordModal user={user} isOpen={pwModalOpen} onClose={() => setPwModalOpen(false)} />
    </div>
  );
}

export default Main;
